'use client';

import { faStarSharp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { useEffect, useRef, useState } from 'react';
import { backgroundColourVariants } from 'src/constants/style';

/**
 * Props for `Testimonials`.
 */
export type TestimonialsProps = SliceComponentProps<Content.TestimonialsSlice>;

/**
 * Component for "Testimonials" Slices.
 */
const Testimonials = ({ slice }: TestimonialsProps): JSX.Element => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const [scrollPositionInitialised, setScrollPositionInitialised] =
        useState(false);

    // Center the scroll position on load
    useEffect(() => {
        if (scrollRef.current && !scrollPositionInitialised) {
            scrollRef.current.scrollLeft =
                (scrollRef.current.scrollWidth -
                    scrollRef.current.clientWidth) /
                2;

            setScrollPositionInitialised(true);
        }
    }, [scrollPositionInitialised, scrollRef]);

    return (
        <section
            className={`${backgroundColourVariants[slice.primary.background_colour]} py-16`}
        >
            <div className="container flex flex-col gap-12">
                {/* Header */}
                <div className="container flex flex-col items-center gap-2 text-black">
                    <h2 className="text-center">{slice.primary.title}</h2>
                    {slice.primary.description ? (
                        <p>{slice.primary.description}</p>
                    ) : null}
                </div>
                {/* Cards */}
                <div
                    className="hide-scrollbar flex flex-row items-stretch gap-4 overflow-x-auto px-4 pb-4"
                    ref={scrollRef}
                >
                    {(slice.primary?.testimonials || []).map((item, index) => (
                        <article
                            key={index}
                            className={`flex min-w-64 flex-col gap-4 rounded-2xl ${backgroundColourVariants['blue-extra-light']} text-black shadow-md md:min-w-[400px]`}
                        >
                            <div className="flex grow flex-col gap-4 p-4">
                                <h4>{item.heading}</h4>
                                {slice.primary.show_star_rating ===
                                    false ? null : (
                                    <div className="flex flex-row items-start gap-[11px]">
                                        {[...Array(5)].map((e, i) => (
                                            <FontAwesomeIcon
                                                key={i}
                                                icon={faStarSharp}
                                                className="text-purple"
                                                size={'lg'}
                                            />
                                        ))}
                                    </div>
                                )}
                                <p>{item.review_text}</p>
                            </div>
                            <div className="flex flex-row p-4">
                                <h5>{item.author}</h5>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
